// services/axiosInterceptor.js
import axios from 'axios';
import config from '../config';
import { toast } from 'react-toastify';
import { resetPerformanceSummaryCache } from '../hooks/usePerformanceSummary';

// Create axios instance with base configuration
const apiClient = axios.create({
  baseURL: config.backend_Url,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Flag to prevent multiple refresh attempts
let isRefreshing = false;
let failedQueue = [];

// Process failed requests after token refresh
const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  
  failedQueue = [];
};

// Request interceptor to add auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("refresh_token");
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // If the data is FormData, remove the default Content-Type to let axios set it automatically
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle token refresh
// apiClient.interceptors.response.use(
//   (response) => {
//     return response;
//   },
//   async (error) => {
//     const originalRequest = error.config;
    
//     // If error is 401 and we haven't already tried to refresh
//     if (error.response?.status === 401 && !originalRequest._retry) {
//       if (isRefreshing) {
//         // If already refreshing, queue this request
//         return new Promise((resolve, reject) => {
//           failedQueue.push({ resolve, reject });
//         }).then(token => {
//           originalRequest.headers.Authorization = `Bearer ${token}`;
//           return apiClient(originalRequest);
//         }).catch(err => {
//           return Promise.reject(err);
//         });
//       }

//       originalRequest._retry = true;
//       isRefreshing = true;

//       try {
//         const refreshToken = sessionStorage.getItem("refresh_token");
        
//         if (!refreshToken) {
//           throw new Error('No refresh token available');
//         }

//         // Call refresh endpoint directly
//         const refreshResponse = await axios.post(`${config.backend_Url}/auth/refresh`, {
//           refresh_token: refreshToken
//         }, {
//           headers: {
//             'accept': 'application/json',
//             'Content-Type': 'application/json'
//           }
//         });

//         const data = refreshResponse.data || {};
//         const success = data.success === true || typeof data.access_token === 'string' || typeof data.token === 'string';
//         if (!success) {
//           throw new Error(data?.message || 'Token refresh failed');
//         }

//         const newAccessToken = data.access_token || data.token;
//         const newRefreshToken = data.refresh_token || null;

//         if (newAccessToken) {
//           sessionStorage.setItem('access_token', newAccessToken);
//         }
//         if (newRefreshToken) {
//           sessionStorage.setItem('refresh_token', newRefreshToken);
//         }

//         // Process queued requests
//         processQueue(null, newAccessToken);

//         // Retry original request with new token
//         originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
//         return apiClient(originalRequest);
//       } catch (refreshError) {
//         // Refresh failed, clear tokens
//         try { sessionStorage.removeItem('access_token'); } catch (_) {}
//         try { sessionStorage.removeItem('refresh_token'); } catch (_) {}
//         processQueue(refreshError, null);
//         return Promise.reject(refreshError);
//       } finally {
//         isRefreshing = false;
//       }
//     }

//     return Promise.reject(error);
//   }
// );

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      toast.error("Session timed out. Redirecting to login...",{theme: "colored"});

      try {
        localStorage.clear();
      } catch (e) {}
      try {
        sessionStorage.clear();
      } catch (e) {}
      try {
        sessionStorage.removeItem("analyticsConfig");
      } catch (e) {}

      resetPerformanceSummaryCache();

      // Redirect
      window.location.href = "/";
    }

    return Promise.reject(error);
  },
);

export default apiClient;
